import { InjectionToken, Type } from '@angular/core';

/**
 * What the sheet viewer's Place on map opens: the place dialog, then the map layer review that publishes it. Both
 * load ArcGIS, so ProjectsModule provides them and the viewer (and its spec) never imports them.
 */
export interface DrawingMapPanels {
  place: Type<unknown>;
  layer: Type<unknown>;
}

export const DRAWING_MAP_PANELS = new InjectionToken<DrawingMapPanels>('DRAWING_MAP_PANELS');
